import { render, staticRenderFns } from "./rechargeRuleList.vue?vue&type=template&id=508e4ce9&"
import script from "./rechargeRuleList.vue?vue&type=script&lang=js&"
export * from "./rechargeRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports